<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form #form="ngForm" class="form-validate">
      <div class="row mb-3">
        <label class="col-form-label col-auto">
          <i class="bi bi-search me-1"></i>ตรวจสอบหลักฐานหลังการเกิดสิทธิ
        </label>
      </div>
      <hr>
      <div class="row mb-3">
        <label for="zone" class="col-xl-2 col-form-label">เขตพื้นที่</label>
        <div class="col-xl-4">
          <app-select-zone id="zone" [disabled]="isZone" name="zone" [(ngModel)]="params.hmainOpZone"></app-select-zone>
        </div>
        <label for="province" class="col-xl-2 col-form-label">จังหวัด</label>
        <div class="col-xl-4">
          <app-province-autocomplete id="province"
                                     name="province"
                                     [restrictZone]="params.hmainOpZone"
                                     [(ngModel)]="params.hmainOpProvince">
          </app-province-autocomplete>
        </div>
      </div>
      <div class="row mb-3">
        <label for="h-type" class="col-xl-2 col-form-label">สังกัดหน่วยงานที่ลงทะเบียน</label>
        <div class="col-xl-4">
          <select id="h-type" class="form-select" name="h-type" [(ngModel)]="params.htype"
                  (ngModelChange)="selectHospitalType()">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option *ngFor="let htype of hospitalType$ | async" [ngValue]="htype">{{ htype.name }}</option>
          </select>
        </div>
        <label for="h-sub-type" class="col-xl-2 col-form-label">ประเภทหน่วยงานที่ลงทะเบียน</label>
        <div class="col-xl-4">
          <select id="h-sub-type" class="form-select" name="h-sub-type"
                  [(ngModel)]="params.hsubType">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option *ngFor="let subtype of params.htype?.subTypes"
                    [ngValue]="subtype">{{ subtype.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <label for="hmainOp" class="col-xl-2 col-form-label">หน่วยบริการที่ได้รับการลงทะเบียน (HMAIN_OP)</label>
        <div class="col-xl-4">
          <app-hospital-autocomplete
            [(ngModel)]="params.hmainOp" name="hmainOp" id="hmainOp"
            [restrictZoneId]="params?.hmainOpZone?.id"
            [restrictProvinceId]="params?.hmainOpProvince?.id"
            [restrictHTypeId]="params?.htype?.id"
            [restrictSubTypeId]="params?.hsubType?.id">
          </app-hospital-autocomplete>
        </div>
        <label class="col-xl-2 col-form-label">แหล่งข้อมูล</label>
        <div class="col-xl-4">
          <div id="register-resource" class="btn-group btn-group-toggle"
               ngbRadioGroup>
            <ng-container *ngIf="regSource">
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="null"> ทั้งหมด
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'SRM'"> {{ regSource.SRM }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'SRM_CITIZEN'"> {{ regSource.SRM_CITIZEN }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'ERM_ONLINE'"> {{ regSource.ERM_ONLINE }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'EFORM'"> {{ regSource.EFORM }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'MOBILE'"> {{ regSource.MOBILE }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'BKK'"> {{ regSource.BKK }}
              </label>
              <label class="btn btn-secondary" ngbButtonLabel>
                <input type="radio" ngbButton [(ngModel)]="params.regSource" name="register-resource"
                       [value]="'LINE_OA'"> {{ regSource.LINE_OA }}
              </label>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <label for="pettition-type" class="col-xl-2 col-form-label">ประเภทการยื่นคำร้อง</label>
        <div class="col-xl-4">
          <select id="pettition-type" class="form-select" name="pettition-type"
                  [(ngModel)]="params.pettitionType">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option [ngValue]="'SELF'">{{ pettitionType.SELF }}</option>
            <option [ngValue]="'DELAGATE'">{{ pettitionType.DELAGATE }}</option>
          </select>
        </div>
        <label for="address-type" class="col-xl-2 col-form-label">ประเภทการพักอาศัย</label>
        <div class="col-xl-4">
          <select id="address-type" class="form-select" name="address-type"
                  [(ngModel)]="params.addressType">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option [ngValue]="'SAME_AS_REGISTERED'">{{ addressType.SAME_AS_REGISTERED }}</option>
            <option [ngValue]="'DIFFERENT_FROM_REGISTERED'">{{ addressType.DIFFERENT_FROM_REGISTERED }}</option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <label for="register-type" class="col-xl-2 col-form-label">ประเภทการลงทะเบียน</label>
        <div class="col-xl-4">
          <select id="register-type" class="form-select" name="register-type"
                  [(ngModel)]="params.regTypeCode">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option *ngFor="let regType of registerType$ | async"
                    [ngValue]="regType.code">{{ regType.name }}
            </option>
          </select>
        </div>
        <label for="right-status" class="col-xl-2 col-form-label">สถานะการตรวจสอบ</label>
        <div class="col-xl-4">
          <select id="right-status" class="form-select" name="right-status"
                  [(ngModel)]="params.considerResultStatus">
            <option [ngValue]="undefined">ทั้งหมด</option>
            <option [ngValue]="'NEW'">{{ considerResultStatus.NEW }}</option>
            <option [ngValue]="'REVISED_CONSIDERATION'">{{ considerResultStatus.REVISED_CONSIDERATION }}</option>
            <option [ngValue]="'APPROVED'">{{ considerResultStatus.APPROVED }}</option>
          </select>
        </div>
      </div>
      <div class="row mb-3">
        <label for="id-card" class="col-xl-2 col-form-label">เลขประจำตัวประชาชน (ผู้ขอลงทะเบียน)</label>
        <div class="col-xl-4">
          <input type="text" class="form-control" id="id-card" name="id-card" [(ngModel)]="params.personalId"
                 placeholder="เลขประจำตัวประชาชน">
        </div>
        <label for="approveName" class="col-xl-2 col-form-label">ผู้ยืนยันรายการ</label>
        <div class="col-xl-4">
          <input type="text" class="form-control" id="approveName" name="approveName" [(ngModel)]="params.considerResultStaffPid"
                 placeholder="เลขประจำตัวประชาชน">
        </div>
      </div>
      <div class="row mb-3">
        <label class="col-xl-2 col-form-label">วันที่เริ่มใช้หน่วยบริการ จากวันที่</label>
        <div class="col-xl-4">
          <gt-ng-datepicker id="start-date" name="start-date"
                            [(ngModel)]="params.startRegEffDate"
                            [minDate]="{year:2020,month:12,day:23}">
          </gt-ng-datepicker>
        </div>
        <label class="col-xl-2 col-form-label">ถึงวันที่</label>
        <div class="col-xl-4">
          <gt-ng-datepicker id="end-date" name="end-date"
                            [(ngModel)]="params.endRegEffDate">
          </gt-ng-datepicker>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-xl-6 text-center">
          <button type="submit" class="btn btn-primary me-3" (click)="search()">
            <i class="bi bi-search me-1"></i>ค้นหา
          </button>
          <button type="submit" class="btn btn-outline-secondary me-3" (click)="reset()">
            <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="row mb-3">
      <div class="text-start col-4">
        <label class="col-form-label col-auto">
          <i class="bi bi-database me-2"></i>ผลการค้นหาตามเงื่อนไข
        </label>
      </div>
      <div class="text-end col-8">
<!--        <button type="button" class="btn btn-success me-2">
          <i class="bi bi-file-excel"></i> ส่งออกรายงาน
        </button>-->
      </div>
    </div>
    <hr>
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <caption>
          ผลการค้นหาตามเงื่อนไขรายการที่ {{ (pageData?.content?.length ? (pageData?.number * pageData?.size) + 1 : 0) | number }}
          - {{ ((pageData?.number) * pageData?.size + pageData?.content?.length) | number }}
          จากทั้งหมด {{ pageData?.totalElements | number }} รายการ
        </caption>
        <thead>
        <tr>
          <th scope="col" class="text-center" rowspan="2" nowrap>ลำดับ</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>เลขที่คำร้อง</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>สถานะ</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ตรวจสอบรายละเอียด</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>แหล่งข้อมูล</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>วันที่เริ่มใช้หน่วยบริการ</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>เลขประจำตัวประชาชน (ผู้ขอลงทะเบียน)</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ชื่อนามสกุล (ผู้ขอลงทะเบียน)</th>
          <th scope="col" class="text-center bg-primary-subtle" colspan="4" nowrap>เครือข่ายหน่วยบริการเดิม</th>
          <th scope="col" class="text-center bg-success-subtle" colspan="4" nowrap>เครือข่ายหน่วยบริการสิทธิ ณ
            ปัจจุบัน
          </th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ประเภทการลงทะเบียน</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ผู้บันทึกข้อมูล</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>หน่วยงานบันทึกข้อมูล</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>จังหวัดหน่วยงานบันทึกข้อมูล</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ประเภทการยื่นคำร้อง</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ประเภทการพักอาศัย</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>เลขประจำตัวประชาชน (ผู้รับมอบอำนาจ)</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>ชื่อนามสกุล (ผู้รับมอบอำนาจ)</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>สิทธิหลัก</th>
          <th scope="col" class="text-center" rowspan="2" nowrap>สิทธิย่อย</th>
        </tr>
        <tr>
          <th scope="col" class="text-center bg-primary-subtle" nowrap>จังหวัดที่ลงทะเบียน</th>
          <th scope="col" class="text-center bg-primary-subtle" nowrap>หน่วยบริการปฐมภูมิ</th>
          <th scope="col" class="text-center bg-primary-subtle" nowrap>หน่วยบริการประจำ</th>
          <th scope="col" class="text-center bg-primary-subtle" nowrap>หน่วยบริการรับส่งต่อ</th>
          <th scope="col" class="text-center bg-success-subtle" nowrap>จังหวัดที่ลงทะเบียน</th>
          <th scope="col" class="text-center bg-success-subtle" nowrap>หน่วยบริการปฐมภูมิ</th>
          <th scope="col" class="text-center bg-success-subtle" nowrap>หน่วยบริการประจำ</th>
          <th scope="col" class="text-center bg-success-subtle" nowrap>หน่วยบริการรับส่งต่อ</th>
        </tr>
        </thead>
        <tbody>
          @for (item of pageData?.content; let i = $index; track item.id) {
            <tr>
              <th scope="row" class="text-center" nowrap>{{ (pageData.size * pageData.number) + (i + 1) }}</th>
              <td nowrap>{{ item.id }}</td>
              <td nowrap>{{ considerResultStatus[item?.considerResultStatus] || 'รอตรวจสอบ' }}</td>
              <td class="text-center" nowrap>
                <button class="btn btn-outline-primary btn-sm" (click)="details(item)">
                  <i class="bi bi-eye"></i> รายละเอียด
                </button>
              </td>
              <td nowrap>{{ regSource[item.regSource] }}</td>
              <td nowrap>{{ item.regEffDate | thaidatetime }}</td>
              <td nowrap>{{ item.personalData?.personalId }}</td>
              <td nowrap>{{ item.personalData?.fullNameWithoutTitle }}</td>
              <td nowrap class="bg-primary-subtle">{{ item.oldPurchaseProvince?.name || '-' }}</td>
              <td nowrap class="bg-primary-subtle">{{ item.oldHospSub?.hname || '-' }}</td>
              <td nowrap class="bg-primary-subtle">{{ item.oldHospMainOp?.hname || '-' }}</td>
              <td nowrap class="bg-primary-subtle">{{ item.oldHospMain?.hname || '-' }}</td>
              <td nowrap class="bg-success-subtle">{{ item.regProvince?.name }}</td>
              <td nowrap class="bg-success-subtle">{{ item.hospSub?.hname || '-' }}</td>
              <td nowrap class="bg-success-subtle">{{ item.hospMainOp?.hname || '-' }}</td>
              <td nowrap class="bg-success-subtle">{{ item.hospMain?.hname || '-' }}</td>
              <td nowrap>{{ item.regTypeName || '-' }}</td>
              <td nowrap>{{ item.createPersonalData?.fullNameWithoutTitle || '-' }}</td>
              <td nowrap>{{ item.createHospital?.hname || '-' }}</td>
              <td nowrap>{{ item.createHospital?.province?.name || '-' }}</td>
              <td nowrap>{{ pettitionType[item.pettitionType] || '-' }}</td>
              <td nowrap>{{ addressType[item.addressType] || '-' }}</td>
              <td nowrap>-</td>
              <td nowrap>-</td>
              <td nowrap>{{ item.mainInscl ? item.mainInscl.rightId + ' - ' + item.mainInscl.rightName : '-' }}</td>
              <td nowrap>{{ item.subInscl ? item.subInscl.inscl + ' - ' + item.subInscl.insclName : '-' }}</td>
            </tr>
          } @empty {
            <tr>
              <td colspan="26">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <ngb-pagination class="d-flex justify-content-center"
                        [maxSize]="5"
                        [rotate]="true"
                        [ellipses]="false"
                        [boundaryLinks]="true"
                        [page]="pageData?.number + 1"
                        (pageChange)="search($event)"
                        [pageSize]="pageData?.size"
                        [collectionSize]="pageData?.totalElements">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
